import { reactive, computed } from '@vue/composition-api'
import { breakComma, formatDateKanji, dateDiff } from '@/util/common'
import * as _ from 'lodash'

export const PurchaseTable = (props, context) => {
  const data = reactive({
    pack: computed(() => props.pack)
  })

  const basicProduct = (pack) => _.filter(pack.product_lists, product => product.classification === 2)
  const optionProduct = (pack) => _.filter(pack.product_lists, product => product.classification === 3)

  const dateString = (date1, date2) => {
    const period = dateDiff(date1, date2)
    const start = formatDateKanji(date1)
    const end = formatDateKanji(date2)

    return `${period}（${start} ~ ${end}）`
  }

  return {
    data,
    basicProduct,
    optionProduct,
    breakComma,
    formatDateKanji,
    dateString
  }
}
